module.exports = __webpack_public_path__ + "static/media/sortNone.5aeb50f3.svg";